export interface PersonalInfo {
  name: string;
  title: string;
  email: string;
  academicEmail: string;
  phone: string;
  location: string;
  social: {
    github: {
      url: string;
      username: string;
    };
    linkedin: {
      url: string;
      username: string;
    };
    instagram: {
      url: string;
      username: string;
    };
    website: {
      url: string;
      name: string;
    };
  };
  about: string;
}

export interface Skill {
  name: string;
  category: string;
  level: number;
}

export interface Project {
  id: number;
  title: string;
  description: string;
  technologies: string[];
  github: string | null;
  demo: string | null;
  image: string | null;
}

export interface Achievement {
  id: number;
  title: string;
  organization: string;
  date: string;
  description: string;
}

export interface Responsibility {
  id: number;
  title: string;
  organization: string;
  location: string;
  period: string;
  description: string;
}

export const personalInfo: PersonalInfo = {
  name: "Aayush Kumar",
  title: "Full-Stack Developer & ML Enthusiast",
  email: "kumataayush@gmail.com",
  academicEmail: "Ak4895@srmist.edu.in",
  phone: "", // Add your phone if you want to display it
  location: "SRM Institute of Science and Technology, Chennai",
  social: {
    github: {
      url: "https://github.com/ak4895",
      username: "ak4895"
    },
    linkedin: {
      url: "https://www.linkedin.com/in/aayush-kumar-439302254",
      username: "aayush-kumar-439302254"
    },
    instagram: {
      url: "https://www.instagram.com/singh_aayush_19",
      username: "singh_aayush_19"
    },
    website: {
      url: "https://aayushkumar.tech",
      name: "aayushkumar.tech"
    }
  },
  about: "Tech enthusiast and student at SRM Institute of Science and Technology. Passionate about building innovative solutions that solve real-world problems. Focused on full-stack development with AI/ML integration. Constantly exploring new technologies and methodologies to enhance my skill set."
};

export const skills: Skill[] = [
  // Programming Languages
  { name: "Python", category: "languages", level: 90 },
  { name: "JavaScript", category: "languages", level: 85 },
  { name: "Java", category: "languages", level: 80 },
  { name: "C++", category: "languages", level: 75 },
  { name: "C", category: "languages", level: 75 },
  
  // Web Development
  { name: "React", category: "frontend", level: 88 },
  { name: "Next.js", category: "frontend", level: 82 },
  { name: "HTML5", category: "frontend", level: 90 },
  { name: "CSS3", category: "frontend", level: 85 },
  
  // Backend & Database
  { name: "Node.js", category: "backend", level: 78 },
  { name: "MongoDB", category: "database", level: 75 },
  { name: "Firebase", category: "backend", level: 80 },
  { name: "Supabase", category: "backend", level: 75 },
  { name: "Clerk", category: "backend", level: 70 },
  { name: "SQL", category: "database", level: 72 },
  
  // DevOps & Tools
  { name: "Docker", category: "devops", level: 65 },
  { name: "Git", category: "tools", level: 85 },
  
  // AI & ML
  { name: "Machine Learning", category: "ai", level: 70 },
  { name: "Data Analysis", category: "ai", level: 75 },
  { name: "NLP", category: "ai", level: 65 },
  { name: "Big Data Tools", category: "ai", level: 60 },
  { name: "Cloud Computing", category: "devops", level: 65 }
];

export const projects: Project[] = [
  {
    id: 1,
    title: "Airline Reservation System",
    description: "A comprehensive airline ticket booking system with user authentication, flight search, and booking management capabilities. Developed in Java with interactive UI, incorporating database connectivity for storing, analyzing, and implementing airline management functionalities.",
    technologies: ["Java", "MySQL", "Swing", "JDBC"],
    github: "https://github.com/ak4895/airline-reservation",
    demo: null,
    image: null, // Add image URL if available
  },
  {
    id: 2,
    title: "Stock Trends Forecast",
    description: "Built an intelligent forecasting model leveraging machine learning and AI to predict stock market trends using sentiment analysis from financial news, company fundamentals, and real-time data via APIs, incorporating Supabase for data storage and retrieval.",
    technologies: ["Python", "Pandas", "Scikit-learn", "TensorFlow", "Flask", "Supabase", "Sentiment Analysis"],
    github: "https://github.com/ak4895/stock-trends",
    demo: null,
    image: null, // Add image URL if available
  },
  {
    id: 3,
    title: "Disease Probability Calculator",
    description: "Developed Python-based disease probability calculation project leveraging analysis of massive datasets from previous patients' symptoms. Implemented effective data processing techniques to derive valuable insights for medical decision-making and enhance disease prediction accuracy.",
    technologies: ["Python", "TensorFlow", "Streamlit", "Data Analysis", "Machine Learning"],
    github: "https://github.com/ak4895/disease-probability-calculator",
    demo: null,
    image: null, // Add image URL if available
  },
  {
    id: 4,
    title: "Portfolio Website",
    description: "A Matrix-themed 3D portfolio website built with React and Three.js, featuring interactive elements and animations.",
    technologies: ["React", "Three.js", "CSS3", "TypeScript"],
    github: "https://github.com/ak4895/portfolio",
    demo: "https://aayushkumar.tech",
    image: null, // Add image URL if available
  },
  {
    id: 5,
    title: "Diabetic Retinopathy Detection",
    description: "Trained an ML model that analyzes retinal images to predict the presence of diabetes by consolidating pictures and analyzing patterns. The system helps in early detection of diabetic retinopathy, a serious eye condition caused by diabetes.",
    technologies: ["Python", "TensorFlow", "Keras", "OpenCV", "Image Processing", "CNN"],
    github: "https://github.com/ak4895/diabetic-retinopathy",
    demo: null,
    image: null,
  },
  {
    id: 6,
    title: "Fuel Cell Anomaly Detection",
    description: "Developed a machine learning-based system to predict and detect anomalies in fuel cell performance, enhancing system reliability and enabling proactive maintenance through real-time data analysis.",
    technologies: ["Python", "scikit-learn", "Pandas", "Time Series Analysis", "Anomaly Detection"],
    github: "https://github.com/ak4895/fuel-cell-anomaly",
    demo: null,
    image: null,
  },
  {
    id: 7,
    title: "Social Media Clustering",
    description: "Worked on a project for social media clustering, grouping data and objects into classes based on their links and attributes. Implemented efficient algorithms to analyze social connections and content similarities.",
    technologies: ["C", "C++", "Graph Algorithms", "Clustering", "Data Structures"],
    github: "https://github.com/ak4895/social-media-clustering",
    demo: null,
    image: null,
  },
  {
    id: 8,
    title: "Todo List iOS App",
    description: "Developed a Todo List iOS app helping people manage their work schedule efficiently. Led a team that won 1st prize in an app development event following a 2-day iOS development workshop.",
    technologies: ["Swift", "UIKit", "CoreData", "iOS"],
    github: "https://github.com/ak4895/todo-list-ios",
    demo: null,
    image: null,
  },
  {
    id: 9,
    title: "Real-Time Data Analytics",
    description: "Processed and analyzed survey data from local social programs to assess impact and efficacy. Facilitated workshop to teach basic data literacy to other volunteers and participants.",
    technologies: ["Python", "Pandas", "Data Visualization", "Statistical Analysis"],
    github: "https://github.com/ak4895/real-time-data-analytics",
    demo: null,
    image: null,
  },
  {
    id: 10,
    title: "AI-Powered PDF Copilot",
    description: "A multi-language foundation model-based tool for extracting insights from PDFs. It provides conversation capabilities with PDFs, allowing users to ask questions about the document's content and receive accurate responses based on the text within the PDF.",
    technologies: ["Python", "LangChain", "LLMs", "HuggingFace", "Vector Databases", "NLP", "PDF Processing"],
    github: "https://github.com/ak4895/pdf-copilot",
    demo: null,
    image: null,
  },
  {
    id: 11,
    title: "MediTrack Health App",
    description: "A comprehensive healthcare application designed to streamline medical record management and appointment scheduling. Features include secure patient data storage, medication reminders, doctor appointment booking, and health metric tracking with visualization of trends over time.",
    technologies: ["Flutter", "Dart", "Firebase", "Cloud Firestore", "Authentication", "Mobile Development"],
    github: "https://github.com/ak4895/meditrack-health",
    demo: null,
    image: null,
  },
  {
    id: 12,
    title: "Smart Home Energy Management",
    description: "IoT-based system for monitoring and optimizing home energy consumption. Uses sensors to collect real-time data and machine learning algorithms to predict usage patterns and suggest optimization strategies. Includes a user-friendly dashboard for tracking energy metrics.",
    technologies: ["IoT", "Raspberry Pi", "Python", "TensorFlow", "MQTT", "Time Series Analysis", "React"],
    github: "https://github.com/ak4895/smart-energy",
    demo: null,
    image: null,
  },
  {
    id: 13,
    title: "Secure File Storage System",
    description: "A blockchain-based system for secure distributed file storage with end-to-end encryption. Implements smart contracts for access control and uses IPFS for decentralized storage. Features include file versioning, granular access permissions, and audit trails.",
    technologies: ["Blockchain", "Solidity", "IPFS", "Ethereum", "Smart Contracts", "Web3.js", "Cryptography"],
    github: "https://github.com/ak4895/secure-files-blockchain",
    demo: null,
    image: null,
  },
  {
    id: 14,
    title: "AR Campus Navigator",
    description: "An augmented reality application that helps students navigate university campuses. Overlays directional information and points of interest on the camera view, providing real-time navigation assistance and location-based information about campus facilities.",
    technologies: ["Unity", "AR Foundation", "C#", "GPS", "Mobile Development", "3D Modeling", "Geospatial Data"],
    github: "https://github.com/ak4895/ar-campus-navigator",
    demo: null,
    image: null,
  },
  {
    id: 15,
    title: "Eco-Friendly Transport Planner",
    description: "A sustainable transportation planning app that calculates carbon footprint for different travel options. Integrates with public transport APIs and suggests eco-friendly routes combining walking, cycling, and public transport to minimize environmental impact.",
    technologies: ["JavaScript", "React Native", "Node.js", "MongoDB", "Google Maps API", "Carbon Footprint Analysis"],
    github: "https://github.com/ak4895/eco-transport-planner",
    demo: null,
    image: null,
  },
  {
    id: 16,
    title: "Virtual Study Group Platform",
    description: "A collaborative learning platform that facilitates virtual study groups with real-time document editing, video conferencing, and scheduling tools. Features AI-powered study recommendations and progress tracking to enhance learning efficiency.",
    technologies: ["React", "WebRTC", "Socket.io", "Express", "MongoDB", "JWT Authentication", "Collaborative Editing"],
    github: "https://github.com/ak4895/virtual-study-platform",
    demo: null,
    image: null,
  },
  {
    id: 17,
    title: "Mental Health Support Chatbot",
    description: "An AI-powered chatbot designed to provide mental health support and resources. Trained on psychological support protocols to offer coping strategies for stress, anxiety, and depression while maintaining user privacy and directing to professional help when needed.",
    technologies: ["Python", "Natural Language Processing", "TensorFlow", "Flask", "Mental Health API", "Sentiment Analysis"],
    github: "https://github.com/ak4895/mental-health-chatbot",
    demo: null,
    image: null,
  },
  {
    id: 18,
    title: "AI Content Generator",
    description: "A sophisticated content generation tool leveraging recent advances in language models. The system creates high-quality blog posts, articles, and marketing copy tailored to specific industries and audience demographics based on minimal input prompts.",
    technologies: ["Python", "GPT", "NLP", "Content Optimization", "SEO Analysis", "Django", "REST API"],
    github: "https://github.com/ak4895/ai-content-generator",
    demo: null,
    image: null,
  }
];

export const achievements: Achievement[] = [
  {
    id: 1,
    title: "Google Gen AI Exchange Hackathon Finalist",
    organization: "Google",
    date: "2023",
    description: "Reached the finals of Google's GenAI Exchange hackathon with an innovative AI-powered solution.",
  },
  {
    id: 2,
    title: "1st Prize in iOS Development Event",
    organization: "SRM Institute of Science and Technology",
    date: "2022",
    description: "Won first place in the iOS app development competition for creating an innovative health-tracking application.",
  },
  {
    id: 3,
    title: "Scholarship Recipient",
    organization: "SRM Institute of Science and Technology",
    date: "2021",
    description: "Received academic scholarship for outstanding performance in computer science coursework.",
  },
];

export const responsibilities: Responsibility[] = [
  {
    id: 1,
    title: "Core Member",
    organization: "Matrix Club",
    location: "SRM Institute",
    period: "2022 - Present",
    description: "Integrated mathematics concepts with technical activities; managed national-level symposiums like Enigma with 500+ participants."
  },
  {
    id: 2,
    title: "Core Member",
    organization: "NIC Club",
    location: "SRM Institute",
    period: "2022 - Present",
    description: "Handled public relations and outreach work, promoting technical events across campus."
  },
  {
    id: 3,
    title: "Core Member",
    organization: "WHHC Club",
    location: "SRM Institute",
    period: "2022 - Present",
    description: "Served as event coordinator for hackathons like Hack Horizons, and competitions including Code in the Dark and Code Golf."
  },
  {
    id: 4,
    title: "PR Team Member",
    organization: "Exadata Club",
    location: "SRM Institute",
    period: "2021 - Present",
    description: "Assisted with symposiums and events management, focusing on participant engagement."
  },
  {
    id: 5,
    title: "Board of Directors - Joint Logistics Head",
    organization: "ARD Club",
    location: "SRM Institute",
    period: "2022 - Present",
    description: "Handled logistics, scheduling, and cross-functional collaboration for technical and non-technical events."
  },
  {
    id: 6,
    title: "Python Mentor",
    organization: "Mentorship Program",
    location: "SRM Institute",
    period: "2023",
    description: "Conducted sessions on Python for 1st-year students, introducing problem-solving strategies and technical challenges."
  },
];